/* global mo, helper */

// JavaScript Document
if(mo.lang === 'ru'){
    $.datepicker.regional['ru'] = {
        clearText: 'Очистить', clearStatus: '',
        minDate: "0",
        closeText: 'Закрыть', closeStatus: '',
        prevText: '<Пред', prevStatus: '',
        nextText: 'След>', nextStatus: '',
        currentText: 'Сегодня', currentStatus: '',
        monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
            'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн',
            'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        monthStatus: '', yearStatus: '',
        weekHeader: 'Не', weekStatus: '',
        dayNames: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
        dayNamesShort: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'сбт'],
        dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        dayStatus: 'DD', dateStatus: 'D, M d',
        dateFormat: 'dd.mm.yy', firstDay: 1,
        initStatus: '', isRTL: false
    };
    $.datepicker.setDefaults($.datepicker.regional['ru']);
}

var hash = location.hash;
$(function(){
    if(window.yaCounter == undefined) window.yaCounter = {
        reachGoal: function(){
        }
    }; // fix, если yandex счетчики запрещены у пользователя

    if(mo.getHash('was_registered')){
        setTimeout(function(){
            yaCounter.reachGoal('registration_attempt', {user_ip: mo.user.ip});
            ga('send', 'event', 'try', 'registration_attempt');

            mo.setHash('was_registered');
        }, 1000);
    }

    // нажатие ctrl (cmd)
    $(document).keydown(function(event){
        if(event.ctrlKey || event.metaKey) $('body').addClass('press_ctrl');
    });
    $(document).keyup(function(event){
        $('body').removeClass('press_ctrl');
    });
    $(document).keypress(function(event){
        $('body').removeClass('press_ctrl');
    });

    // Настройка всплывающих окон
    $.extend($.ui.dialog.prototype.options, {
        focus: function(event, ui){
            setTimeout(function(){
                if($('[autofocus]', event.target).length) return;
                $('.modal-footer button:first, .modal-body input:first, [autofocus]:first', event.target).focus();
            });
        },
        //hide: 'fade',
        //show: 'fade',
        modal: true,
        resizable: false,
        width: 945,
        minHeight: 0
    });
    $.extend($.ui.sortable.prototype.options, {
        placeholder: "placeholder"
    });

    // Диалоги
    $(document).on('click', '.modal-header .close, .modal-footer .btn_close', function(){
        $(this).parents('.ui-dialog-content').dialog('close');
        return false;
    });
    $(document).on('click', '[data-toggle=dialog]', function(){
        var $dialog = $($(this).attr('data-target'));
        var options = $.evalJSON($dialog.attr('data-options'));
        $dialog.dialog(options);
        return false;
    });
    $(document).on('click', '.ui-widget-overlay', function(){
        $('.ui-dialog:visible:last .ui-dialog-content').dialog('close');
    });

    // Подсказки
    tooltip_init();

    // написание чисел
    $.map($('.number_format'), function(el){
        $(el).text(addCommasWhite($(el).text()));
    });


    // меню пользователя
    var profileMenu = false;
    $('#top_panel .user').click(function(event){
        event.preventDefault();
        $('#top_panel .profile_wrapper').addClass('open');
        profileMenu = true;
        $(document).bind('click.profileMenu', function(e){
            if(!profileMenu && $(e.target).closest('#leftmenu').length == 0){
                $('#top_panel .profile_wrapper').removeClass('open');
                $(document).unbind('click.profileMenu');
            }
            profileMenu = false;
        });
    });

    // Табы

    $('.nav-tabs a[href*="#"]').click(function(event){
//		event.preventDefault();
//		mo.setHash('nav-tabs', $(this).attr('href'));

        var a_pathname = $(this).attr('href').replace(/#(.*)/, '');
        if(a_pathname && a_pathname != location.pathname) return; // ссылка на вкладку на другой странице

        var id = 'tab_' + $(this).attr('href').match(/#(.*)/)[1];
        $('#' + id).addClass('active').siblings().removeClass('active');

        $(this).addClass('active').siblings().removeClass('active');
    });
    if(mo.getParam('nav-tabs')) hash = mo.getParam('nav-tabs');
    $('.nav-tabs a[href*="' + hash + '"]').eq(0).click();

    // to_top
    $(window).scroll(function(){
        if($(window).scrollTop() > 500){
            $('#to_top').fadeIn();
        }else{
            $('#to_top').fadeOut();
        }
    });
    $('#to_top').click(function(){
        if($(window).scrollTop() > 2000){
            $(window).scrollTop(100);
            $('#to_top').data('duration', 300);

            setTimeout(function(){
                $('#to_top').data('duration', null);
            }, 100);
        }
    });

    // плавная прокрутка
    $('a.scroll-to').bind('click', function(){
        var shift = $(this).data('shift') || 0;
        return helper.animateScrollTo($(this).attr('href'), shift);
    });

    // Спойлер
    $(document).on('click', '.spoiler-head', function(){
        var $head = $(this);
        var $body = $(this).next('.spoiler-body');
        $(this).toggleClass('active');
        $('.icon', $head).toggleClass('icon-caret-right').toggleClass('icon-caret-down');
        $body.slideToggle();

        if($body.is('.cookie') && $body.attr('id')) $.cookie($body.attr('id') + '_opened', $(this).is('.active')); // при необходимости запомнить открытость спойлера
    });
    $.map($('.spoiler-body'), function(el){
        if(!$(el).is('.cookie')) return;

        if($.cookie($(el).attr('id') + '_opened') == 'true'){
            var $head = $(el).prev('.spoiler-head');
            $head.addClass('active');
            $('.icon', $head).removeClass('icon-caret-right').toggleClass('icon-caret-down');
            $(el).show();
        }
    });

    // next_block
    $('body').on('click', '.next_block a', function(event){
        event.preventDefault();

        $(this).siblings('a').removeClass('active');
        $(this).addClass('active');
    });

    // contextmenu
    $(document).on('click', '[data-contextmenu-id]', function(event){
        if($(event.target).parents('.contextmenu').length) return; // клик внутри открытого меню
        event.preventDefault();

        if($(this).data('opened')) return;
        $(this).data('opened', true);
        if($(this).css('position') != 'absolute') $(this).css({position: 'relative'});
        $(this).show();

        var $contextmenu = $('#' + $(this).attr('data-contextmenu-id'));
        $contextmenu_opener = $(this);
        if(!$contextmenu.length) return;
        $contextmenu.addClass('contextmenu');
        $contextmenu = $contextmenu.clone().removeClass('template');
        if($contextmenu.is('.top, .right, .bottom, .left')) $contextmenu.append('<div class="triangle"></div>');
        if($contextmenu.is('.with_close')) $contextmenu.append('<a href="." title="Закрыть" class="close closer icon-remove"></a>');

        $contextmenu
        .insertAfter($contextmenu_opener)
        .show();

        // положение котнекстного меню
        var w = $contextmenu_opener.width() + $contextmenu_opener.css('padding-right').replace('px', '') * 1 + $contextmenu_opener.css('padding-left').replace('px', '') * 1;
        var h = $contextmenu_opener.height() + $contextmenu_opener.css('padding-top').replace('px', '') * 1 + $contextmenu_opener.css('padding-bottom').replace('px', '') * 1;
        var left = $contextmenu_opener.offset().left - $contextmenu_opener.offsetParent().offset().left;
        var top = $contextmenu_opener.offset().top - $contextmenu_opener.offsetParent().offset().top;

        if($contextmenu.is('.top')){
            left += w / 2;
            top -= $contextmenu.height() + $('.triangle', $contextmenu).height() + 5;
        }

        if($contextmenu.is('.right')){
            left += w + $('.triangle', $contextmenu).width() + 5;
        }

        if($contextmenu.is('.bottom')){
            left += w / 2;
            top += h;
        }

        if($contextmenu.is('.left')){
            left -= $contextmenu.width() + $('.triangle', $contextmenu).width() + 5;
        }

        // контроль за тем, чтобы контекстное меню не вылезало за ширину экрана
        //var opener_left = $contextmenu_opener.offset().left;
        var opener_left = 0;
        var win_w = $(document).width();
        var max_left = win_w - opener_left - $contextmenu.width();

        if(left > max_left){
            left = max_left;
            $contextmenu.addClass('no_right');
        }

        $contextmenu.css({
            left: left,
            top: top
        });
        // /положение котнекстного меню

        $contextmenu.data('close', function(){
            $contextmenu_opener.data('opened', '');
            $contextmenu.remove();

            $('body :not(.contextmenu)').unbind('mousedown.no_contextmenu');
        });

        // закрытие при клике вне контекстного меню (кроме виджета календаря)
        var firstClick = true;
        $('body :not(.ui-datepicker)').bind('mousedown.no_contextmenu', function(event){
            if(!$contextmenu.length) return; // контекстное меню было удалено

            setTimeout(function(){
                firstClick = true;
            });
            if(!firstClick) return; // клик на внешнем элементе
            firstClick = false;

            if($(this).closest('.contextmenu').length) return; // клик внутри контекстного меню

            if($contextmenu.data('close')) $contextmenu.data('close')();
        });

        return false;
    });
    $(document).on('click', '.closer, .contextmenu ul a:not([target])', function(event){
        if($(this).attr('href') == '.') event.preventDefault();
        if($(this).parents('.contextmenu').data('close') == undefined) return;

        $(this).parents('.contextmenu').data('close')();
    });

    $(window).resize(window_resize);
    $('.tabs a, #sidemenu a').click(window_resize);
    window_resize();

    // ###################избранные базы

    // добавить базу в избранную папку
    $(document).on('click', '.base_thumb .favor_status, #bases_results .el .leftside .favor_status', function(event){
        event.preventDefault();
        if(mo.user.id == -1){
            $("#top_panel .login").click();
            return false;
        }
        let $el = $(this).closest('.el'),
            on = (($(this).attr('rel') * 1) ? 0 : 1),
            id = $el.data('id');

        let data = {
            oper: 'edit',
            id: id,
            on: on
        };

        mo.edit(function(){
            $('.base_thumb[data-id="' + id + '"] .favor_status').toggleClass("checked").attr('rel', on);
            $('#bases_results .el[data-id="' + id + '"] .leftside .favor_status').toggleClass("checked").attr('rel', on);

            if(!on && $el.closest('#favorites').length) $el.remove();


        }, 'bases', 'favorite', data);
    });

    //----------------------------------- Показать контакты базы -------------------------
    $(document).on('click', '.base_thumb .contacts_block .button', function(event){
        event.preventDefault();
        if(!$(this).is('.open')) $(this).addClass('open');
    });
    $(document).on('touchstart', '.base_thumb .contacts_block .button.open', function(event){
        event.preventDefault();
        var phone_number = $('.base_phone').data('phone');
        location.href = 'tel:' + phone_number;
    });


    // ---------------------------------- мобильная версия---------------------------------
    $('#top_panel').on('click', '.menu_block_field', function(){
        $('.right_block.menu_block').removeClass('open');
        $('.left_block.menu_block').removeClass('open');
        $(this).remove();
    });

    $('#top_panel .show_menu').click(function(event){
        event.preventDefault();

        if($(this).is('.left')){
            $('.left_block.menu_block').toggleClass('open');
            $('.right_block.menu_block').removeClass('open');
        }

        if($(this).is('.right')){
            $('.right_block.menu_block').toggleClass('open');
            $('.left_block.menu_block').removeClass('open');
        }
        // показ поиска
        if($(this).is('.search_block')){
            $('#bases_search_wrapper').toggleClass('open');
        }
        $('.menu_block.open').after('<div class="menu_block_field"></div>')
    });


    $('.mobile_site_menu .title').click(function(){
        $(this).closest('li').toggleClass('active');
    });

    // ---------------------------------- /мобильная версия---------------------------------


    $(document).on('click', '[data-phone-hidden-btn]', function() {
        var phone = $(this).attr('data-phone-hidden-btn');
        $(this).find('[data-phone-hidden]').text(phone);
    });
});

function tooltip_init(){
    $.map($('.tooltip'), function(el){
        var left = $(el).is('.left');
        var bottom = $(el).is('.bottom');

        var $el = $(el);
        if($el.parent().is('.tooltip_click')) $el.height($el.parent().height());

        var el_h = $el.outerHeight() - 15;
        if(!bottom) el_h -= 15;

        var my = '';
        var at = '';
        if(left){
            my = 'left';
            at = 'left';
        }else{
            my = 'center';
            at = 'center';
        }
        if(bottom){
            my += ' top+' + el_h;
            at += ' bottom';
        }else{
            my += ' bottom-' + el_h;
            at += ' top';
        }

        var tooltip_content = '';
        try{
            tooltip_content = decodeURIComponent($(el).attr('title').toString())
        }catch(e){
            console.log('Ошибка ' + e.name + ":" + e.message + "\n" + e.stack);
            tooltip_content = $(el).attr('title');
        }

        $(el).tooltip({
            position: {
                my: my,
                at: at,
                using: function(position, feedback){
                    $(this).css(position);

                    var _class = 'arrow';
                    if(left) _class += ' left';
                    if(feedback.vertical != 'bottom') _class += ' bottom';
                    $("<div>").addClass(_class).appendTo(this);
                }
            },
            /* task 3992 - start */
            // если данные для подсказки завёрнуты в urlencode - разворачиваем
            content: tooltip_content,
            // content: $(el).attr('title').toString(),
            /* task 3992 - end */
            close: function(event, ui){
                $(".ui-helper-hidden-accessible").remove();
            }
        });
    });

    // кнопка прокрутки вверх
    var $upBut = $('a.scrollTop');
    $(window).scroll(function(){
        $upBut['fade' + ($(this).scrollTop() > 200 ? 'In' : 'Out')](500);
    });

    $upBut.click(function(event){
        event.preventDefault();
        $('html, body').animate({scrollTop: 0}, 500);
    });
}

function window_resize(){
    // автоматическая высота
    var footer_h = 0,
        footer_el = $('#footer');

    if(footer_el.length){
        footer_h =
            footer_el.height() +
            footer_el.css('padding-top').replace('px', '') * 1 +
            footer_el.css('padding-bottom').replace('px', '') * 1
        ;
    }

    $.map($('.auto_height'), function(el){
        $(el).css({'min-height': 0});

        var parents_padding_margin_bottom = 0;

        var min_h =
            $(window).height() -
            $(el).css('padding-top').replace('px', '') * 1 -
            $(el).css('padding-bottom').replace('px', '') * 1 -
            $(el).css('margin-top').replace('px', '') * 1 -
            $(el).css('margin-bottom').replace('px', '') * 1 -
            $(el).offset().top -
            footer_h -
            parents_padding_margin_bottom
        ;

        $(el).css({'min-height': min_h});
    });
}